import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
// import Fab from '@material-ui/core/Fab';
// import CheckIcon from '@material-ui/icons/Check';
// import SaveIcon from '@material-ui/icons/Save';
import my_styles from '../my-styles';
const styles = my_styles.MUICircularLoadButton_styles;

function CircularIntegration({
  classes,
  isLoading,
  isSuccess,
  text,
  onClick,
  type,
  children //text
}) {
  const buttonClassname = classNames({
    [classes.buttonSuccess]: isSuccess
  });

  console.log(classes.buttonProgress);

  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        <Button
          type={type}
          variant="contained"
          className={buttonClassname}
          disabled={isLoading}
          onClick={onClick}
        >
          {children}
        </Button>
        {isLoading && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
      </div>
    </div>
  );
}

export default withStyles(styles)(CircularIntegration);
